import { appApiHeaders, getApiUrl } from '@/utils/api-utils'
import { apiCall } from '@ngtrvu/use-api'

const FETCH_LINK_METADATA = 'FETCH_LINK_METADATA'

export const getLinkMetadataApi = apiCall(
  FETCH_LINK_METADATA,
  ({ url }: { url: string }) => ({
    endpoint: getApiUrl('/api/cms/v1/link-metadata'),
    method: 'POST',
    headers: appApiHeaders(),
    body: { url },
  }),
)
